import { useRef, useState, useEffect } from "react";

import { Button } from "reactstrap";

//Unform e componentes
import { useField } from "@unform/core";
import CurrencyInput from "react-currency-input-field";
import TooltipItem from "../TooltipItem";

//Common
import { SHOW_DESC_OBRIGATORIO_FIELDS } from "@/common/constantes";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";

function UInputCurrency({
  name,
  label,
  type,
  decimalsLimit = 2,
  allowNegative = false,
  allowNull = false,
  showMascara = false,
  defaultValue,
  value, //novo
  textHelp,
  className = "",
  footer,
  showButton = false,
  onClickButton = null,
  buttonConsulta = false, //o botão abre só para consulta (ícone e dica de consultar no lugar de editar)
  sm = false,
  ...rest
}) {
  const inputRef = useRef(null);
  const {
    fieldName,
    registerField,
    error,
    defaultValue: valueDef,
  } = useField(name);

  // const [num, setNumber] = useState(
  //   Number(value ?? defaultValue ?? valueDef ?? 0).toFixed(decimalsLimit),
  // );

  const [num, setNumber] = useState(
    allowNull && value == null
      ? ""
      : Number(value ?? defaultValue ?? valueDef ?? 0).toFixed(decimalsLimit),
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,

      getValue: () => Number(String(num).replace(/,/g, ".")),

      setValue: (ref, value) => {
        //setNumber(Number(value || 0).toFixed(decimalsLimit));
        if (allowNull && value == null) {
          setNumber("");
        } else {
          setNumber(Number(value || 0).toFixed(decimalsLimit));
        }
      },

      clearValue: (ref) => {
        ref.current.value = "";
      },
    });
  }, [fieldName, registerField, num, decimalsLimit]);

  //Atualiza o estado quando defaultValue mudar
  useEffect(() => {
    //setNumber(Number(value ?? defaultValue ?? 0).toFixed(decimalsLimit));

    if (allowNull && value == null) {
      setNumber("");
    } else {
      setNumber(Number(value ?? defaultValue ?? 0).toFixed(decimalsLimit));
    }
  }, [value, defaultValue, decimalsLimit, allowNull]);

  //### EVENTOS ###
  //onValueChange
  function handleValueChange(valor) {
    if (allowNull && valor == null) {
      setNumber("");
    } else {
      setNumber(valor);
    }
  }

  return (
    <div className={label != null ? "form-group" : ""}>
      {label && (
        <label htmlFor={fieldName} className={sm ? "texto-menor" : "label"}>
          {label}
          {textHelp && (
            <span>
              <TooltipItem text={textHelp} showImageHelp />{" "}
            </span>
          )}
        </label>
      )}

      <div className="d-flex">
        <CurrencyInput
          ref={inputRef}
          id={fieldName}
          name={fieldName}
          autoComplete="off"
          allowNegativeValue={allowNegative}
          groupSeparator={type == "percent" ? "" : "."}
          decimalSeparator=","
          decimalsLimit={decimalsLimit}
          suffix={showMascara && type == "percent" ? "%" : ""}
          prefix={showMascara && type != "percent" ? "R$ " : ""}
          value={num}
          onValueChange={handleValueChange}
          className={`form-control ${className} ${error && SHOW_DESC_OBRIGATORIO_FIELDS == false ? " error" : ""} 
              ${sm ? " texto-menor" : ""}`}
          style={
            showButton
              ? {
                  borderRadius: "6px 0px 0px 6px",
                }
              : {}
          }
          {...rest}
        />

        {showButton && (
          <Button
            name="btnEditar"
            color="light"
            className={`btn-input-currency${sm ? "-sm" : ""}`}
            title={buttonConsulta ? "Consultar" : "Editar"}
            onClick={onClickButton}
          >
            {buttonConsulta ? ICONES_BOTAO.CONSULTAR : ICONES_BOTAO.EDITAR}
          </Button>
        )}
      </div>

      {footer && <div className="texto-menor">{footer}</div>}

      {error && SHOW_DESC_OBRIGATORIO_FIELDS == true && (
        <small className="text-danger">{error}</small>
      )}
    </div>
  );
}

export default UInputCurrency;
